module.exports = __webpack_public_path__ + "media/packs/images/flags/EC-6aa83ef81e07babf75aea0f6eaa6ab67.svg";